module.exports = __webpack_public_path__ + "static/media/elements_section2_slide3.9299e33d.png";